{
    "NAME": "LicenseManagementLanguage",
    "LicenseManagement_Action_Refresh": "Refresh licence status",
    "LicenseManagement_Action_Reload": "Reload licences",
    "LicenseManagement_Reload_Confirm": "Reload licence data?",
    "LicenseManagement_Reload_Success": "Licence data reloaded.",
    "LicenseManagement_Status_Title": "Current Licence Status",
    "LicenseManagement_Status_Empty": "No licence status is available.",
    "LicenseManagement_Status_LimitedAccess": "Only the overall licence status is available for the current scope.",
    "LicenseManagement_Status_Entry": "Entry",
    "LicenseManagement_Status_Value": "Value",
    "LicenseManagement_Status_Usage": "Usage",
    "LicenseManagement_Status_Status": "Status",
    "LicenseManagement_Profiles_Title": "Telephony Server Profiles",
    "LicenseManagement_Profiles_Empty": "No telephony server profiles are available.",
    "LicenseManagement_Billing_Title": "Billing Reports",
    "LicenseManagement_Billing_Filters": "Filters",
    "LicenseManagement_Billing_Advanced": "Advanced Options",
    "LicenseManagement_Billing_Actions": "Actions",
    "LicenseManagement_Billing_OnlyBillable": "Only billable configuration",
    "LicenseManagement_Billing_SystemWideUsers": "Include system-wide users",
    "LicenseManagement_Billing_BillingExcluded": "Include billing-excluded configurations",
    "LicenseManagement_Billing_Simulation": "Include simulation telephone systems",
    "LicenseManagement_Billing_Summary": "Billing Summary",
    "LicenseManagement_Billing_Cdr": "Billing CDRs",
    "LicenseManagement_Billing_SummaryConfirm": "Generate the billing summary report?",
    "LicenseManagement_Billing_CdrConfirm": "Generate the billing CDR report?",
    "LicenseManagement_Diagnostic": "Diagnostic Report",
    "LicenseManagement_Diagnostic_Confirm": "Generate the diagnostic licence report?",
    "LicenseManagement_Filter_Cme": "CME",
    "LicenseManagement_Filter_TelSys": "Telephony Server",
    "LicenseManagement_Filter_Partition": "Partition"
}
